































































import Vue, { PropType } from 'vue'
import { validFormats } from '@/utils/shared'
import { FormatType, SettingParametersType } from '@/types'

export default Vue.extend({
  props: {
    resource: {
      type: Object as PropType<FormatType>,
      required: true
    }
  },
  data () {
    return {
      menuSelected: 'none' as string,
      formatTypes: ['vw', 'vh', 'px', 'em', 'rem', '%'] as string[]
    }
  },
  computed: {
    popupSrc (): FormatType {
      const src = Object.assign({}, this.resource)
      const exp = validFormats(src.value, this.formatTypes as string[])
      if (!exp) {
        this.setMenuSelected('none')
        return src
      }

      const [value, e] = exp
      this.setMenuSelected(e)
      src.value = value
      return src
    },
    newValue () {
      const type = this.getType() as string
      const popupSrc = this.popupSrc as FormatType
      return popupSrc.value + type || ''
    },
    label (): string {
      if (!this.resource) return ''

      const { group = '' } = this.resource
      return group
    },
    isColorSetting (): boolean {
      const popupSrc = this.popupSrc as FormatType
      return popupSrc && popupSrc.group === 'colors'
    },
    inputType () {
      const isColorSetting = this.isColorSetting as boolean
      const popupSrc = this.popupSrc as FormatType
      return isColorSetting ? 'color' : popupSrc.type || 'text'
    }
  },
  mounted () {
    this.focus()
    window.addEventListener('keyup', this.keyEventHandler)
  },
  methods: {
    keyEventHandler (event: KeyboardEvent) {
      if (event.keyCode === 27) {
        this.close()
      }
    },
    getType (): string {
      return this.menuSelected !== 'none' ? this.menuSelected || '' : ''
    },
    update () {
      const group = this.popupSrc.group || ''
      const subKey = this.popupSrc.id
      const newValue = this.newValue
      const changeEvent: SettingParametersType = {
        group,
        oldItem: {
          key: this.resource.id,
          value: this.resource.value
        },
        newItem: {
          key: subKey,
          value: newValue
        }
      }
      this.$emit('update', changeEvent)
    },
    setMenuSelected (value: string): void {
      this.menuSelected = value
    },
    close (): void {
      this.$emit('on-close')
    },
    focus (): void {
      const keyInputElm = this.$refs.keyInput as HTMLInputElement
      const valueInputElm = this.$refs.valueInput as HTMLInputElement
      if (!this.resource.label) return keyInputElm.focus()

      valueInputElm.focus()
    }
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.keyEventHandler)
  }
})
